<template>
  <div class="px-3 py-1">
    <span class="text-caption grey--text">{{ title }}</span>
    <div class="body-2">{{ content }}</div>
  </div>
</template>
<script>
export default {
  name: 'ShootingItemContent',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  }
}
</script>
